var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNbMarcheIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "monte-a-letage",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_241",
    "data-name": "Trac\\xE9 241",
    d: "M3.953-511.012v.988H5.231a12.4,12.4,0,0,1,1.279.031c0,.016-1.465,1.492-3.255,3.282L0-503.455l.686.686.69.69,3.255-3.255c1.79-1.79,3.267-3.255,3.286-3.255s.027.573.027,1.279v1.279H9.92V-512H3.953Z",
    transform: "translate(0 512)",
    fill: "#c52b30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_242",
    "data-name": "Trac\\xE9 242",
    d: "M18-458.54v2.46H13.219v4.873H8.391v4.873H3.609v4.921H0v2.437H6v-4.873h4.781l.009-2.451.014-2.446,2.4-.014,2.4-.01v-4.873h4.781l.009-2.451.014-2.446,1.8-.014,1.791-.01V-461H18Z",
    transform: "translate(0 462.976)",
    fill: "#c52b30"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbMarcheIcon);
export default __webpack_public_path__ + "static/media/NbMarcheIcon.c8c7ce1f9e8cb383fa28535bf2f7d184.svg";
export { ForwardRef as ReactComponent };